export const PROJECT = {
  TYPE: {
    INDUSTRIAL: 'INDUSTRIAL',
    REGULAR: 'REGULAR'
  },
  STATUS: {
    CREATING_QUOTE: 'CREATING_QUOTE',
    REQUEST_QUOTE: 'REQUEST_QUOTE',
    COMPLETE_QUOTE: 'COMPLETE_QUOTE',
    CREATING_CONTRACT: 'CREATING_CONTRACT',
    REQUEST_CONTRACT: 'REQUEST_CONTRACT',
    COMPLETE_CONTRACT: 'COMPLETE_CONTRACT',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETE: 'COMPLETE',
    CANCEL: 'CANCEL'
  },

  PROJECT_STATUS_LABEL: {
    REQUEST_QUOTE: '見積依頼',
    COMPLETE_QUOTE: '見積完了',
    CREATING_CONTRACT: '契約書作成',
    REQUEST_CONTRACT: '契約書依頼',
    COMPLETE_CONTRACT: '契約書完了',
    IN_PROGRESS: '進行中',
    COMPLETE: '完了',
    CANCEL: 'キャンセル'
  },
  PROJECT_STATUS_COLOR: {
    // CREATING_QUOTE: '#ff6f91',
    REQUEST_QUOTE: '#60A5FA',
    COMPLETE_QUOTE: '#60A5FA',
    CREATING_CONTRACT: '#60A5FA',
    REQUEST_CONTRACT: '#60A5FA',
    COMPLETE_CONTRACT: '#60A5FA',
    IN_PROGRESS: '#60A5FA',
    COMPLETE: '#d0d0d0',
    CANCEL: '#d0d0d0'
  },
  PROJECT_STATUS_CLASS: {
    // CREATING_QUOTE: 'pink-status',
    REQUEST_QUOTE: 'blue-status',
    COMPLETE_QUOTE: 'red-status',
    CREATING_CONTRACT: 'blue-status',
    REQUEST_CONTRACT: 'blue-status',
    COMPLETE_CONTRACT: 'red-status',
    IN_PROGRESS: 'blue-status',
    COMPLETE: 'gray-status',
    CANCEL: 'gray-status'
  },
  STATUS_COLOR: {
    COMPLETE_QUOTE: '#60A5FA',
    CREATING_CONTRACT: '#60A5FA',
    REQUEST_CONTRACT: '#60A5FA',
    COMPLETE_CONTRACT: '#60A5FA',
    IN_PROGRESS: '#60A5FA',
    COMPLETE: '#d0d0d0',
    CANCEL: '#d0d0d0'
  },
  STATUS_LABEL: {
    COMPLETE_QUOTE: '契約書作成',
    CREATING_CONTRACT: '契約書作成',
    REQUEST_CONTRACT: '契約書依頼',
    COMPLETE_CONTRACT: '契約書完了',
    IN_PROGRESS: '進行中',
    COMPLETE: '完了',
    CANCEL: 'キャンセル'
  },
  STATUS_CLASS: {
    COMPLETE_QUOTE: 'blue-status',
    CREATING_CONTRACT: 'blue-status',
    REQUEST_CONTRACT: 'blue-status',
    COMPLETE_CONTRACT: 'red-status',
    IN_PROGRESS: 'blue-status',
    COMPLETE: 'gray-status',
    CANCEL: 'gray-status'
  },
  STATUS_TW_CLASS: {
    CREATING_QUOTE: 'bg-F67E7E',
    REQUEST_QUOTE: 'bg-4294FF',
    COMPLETE_QUOTE: 'bg-F67E7E',
    CREATING_CONTRACT: 'bg-4294FF',
    REQUEST_CONTRACT: 'bg-4294FF',
    COMPLETE_CONTRACT: 'bg-F67E7E',
    IN_PROGRESS: 'bg-4294FF',
    COMPLETE: 'bg-bfbfbf',
    CANCEL: 'bg-bfbfbf'
  },
  CREATE_REGULAR_STATUS: {
    NOTHING: -1,
    SUCCESS: 1,
    FAIL: 0,
    WARNING: 2,
    WARNING_VALUE: {
      NOTHING: 0,
      LEAST_ONE: 1,
      MISS_INFORMATION: 2
    }
  },
  FILE_TYPE: {
    WASTE_DETAIL: 'WASTE_DETAIL',
    QUOTATION: 'QUOTATION',
    ESTIMATE: 'ESTIMATE'
  },
  CONTRACT_AUTO_RENEWAL: {
    CONTINUE: 'CONTINUE',
    END: 'END'
  }
};
